
import React from "react";
import styles from "../../assets/style.module.css";

export interface SectionHeaderProps {
    title: string;
    eyebrow: string;
    titleEm?: string;
    subtitle?: string;
    as?: "h1" | "h2";
    action?: React.ReactNode;
}

function SectionHeader({ eyebrow, title, titleEm, subtitle, action, as: Heading = "h2" }: SectionHeaderProps) {
    return (<div className={styles["sec-head"]}>
        <div>
            <div className={styles["eyebrow"]}>{eyebrow}</div>
            <Heading className={styles["sec-title"]}>
                {title}{titleEm && (<><br /><em>{titleEm}</em></>)}
            </Heading>
            {subtitle && (<p className={styles["sec-sub"]}>{subtitle}</p>)}
        </div>
        {action}
    </div>);
}

export default SectionHeader;
